'use strict';

const lodashPartialRight = require('lodash.partialright');
const tradeTourRule = require('./tradeTourRule');

const {type: {NET_PRICE_TOUR}} = require('../../../components/Tour/TourStore');
const netPriceRule = lodashPartialRight(tradeTourRule, {
    type: NET_PRICE_TOUR,
    limit: 3
});

module.exports = netPriceRule;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/netPriceRule.es.js